export const getCrossListedProducts = (app) => {
  const value =
    app?.customProps?.crossListedIn ||
    app?.customProps?.['marketplace.crossListedIn'] ||
    ''

  return value
    .split(',')
    .map((slug) => slug.trim())
    .filter(Boolean)
}
